/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import {
  Gantt,
  Task,
  EventOption,
  StylingOption,
  ViewMode,
  DisplayOption,
} from "gantt-task-react";
import "gantt-task-react/dist/index.css";

import { assetImages } from "constants";
import TaskManagementPopup from "components/Common/Popup/TaskManagementPopup/TaskManagementPopup";
import { getConvertedGanttDate } from "helper/TimeCalculation";
import MyTaskFilterPopup from "components/Common/Popup/MyTaskFilterPopup";
import UpdateGanttTaskModal from "components/Common/Modal/UpdateGanttTaskModal";
import { GanttViewSwitcher } from "./GanttViewSwitcher";
import MyTaskGanttHeader from "./Header/MyTaskGanttHeader";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { useTranslation } from "react-i18next";
import {
  getCurrentMonthFirstDate,
  getMonthOfTheDate,
} from "helper/Common/CommonHelper";
import TaskAdvanceFilterPopup from "components/Common/Popup/TaskAdvanceFilterPopup";

const MyTaskGanttBody = () => {
  const params = useParams();

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [memberList, setMemberList] = useState([]);

  const [selectedEditTaskId, setSelectedEditTaskId] = useState(null);

  /* -------------- Requirements for view change -------------- */
  const [view, setView] = useState(ViewMode.Month);
  const [ganttViewStartDate, setGanttViewStartDate] = useState(
    getCurrentMonthFirstDate(),
  );
  const [isChecked, setIsChecked] = useState(true);

  const [isProjectModerator, setisProjectModerator] = useState(false);
  const [selectedTaskModerator, setselectedTaskModerator] = useState(null);

  const [hideEmptyMessage, setHideEmptyMessage] = useState(true);
  const [taskList, setTaskList] = useState([]);

  const [errorMessage, seterrorMessage] = useState("");

  const [filterTaskDateRangeType, setFilterTaskDateRangeType] = useState("");
  const [filterTaskFromDate, setfilterTaskFromDate] = useState("");
  const [filterTaskToDate, setfilterTaskToDate] = useState("");

  const [filterTaskCustomIds, setfilterTaskCustomIds] = useState([]);
  const [filterTaskTitle, setfilterTaskTitle] = useState("");
  const [filterTaskProjects, setfilterTaskProjects] = useState([]);
  const [filterTaskAssignedToUsers, setfilterTaskAssignedToUsers] = useState(
    [],
  );
  const [filterTaskAssignedByUsers, setfilterTaskAssignedByUsers] = useState(
    [],
  );
  const [filterTaskStatus, setfilterTaskStatus] = useState([]);
  const [filterTaskPriorities, setfilterTaskPriorities] = useState([]);
  const [filterTaskLabels, setfilterTaskLabels] = useState([]);

  const [showUpdateButtons, setShowUpdateButtons] = useState(false);
  const [updatedTaskId, setUpdatedTaskId] = useState(null);
  const [updatedStartDate, setUpdatedStartDate] = useState("");
  const [updatedEndDate, setUpdatedEndDate] = useState("");

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  let columnWidth = 65;

  if (view === ViewMode.Month) {
    columnWidth = 300;
  } else if (view === ViewMode.Week) {
    columnWidth = 250;
  }

  //get all tasks
  const getAllTask = async () => {
    let isModerator = false;

    if (
      userInfo.role.slug === "ADMIN" ||
      userInfo.role.slug === "SUPER_ADMIN"
    ) {
      isModerator = true;
    }

    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TASKS +
        `?token=${token}&ismoderator=${isModerator}`;

      if (filterTaskDateRangeType != "") {
        requestUrl =
          requestUrl + `&filterdaterangetype=${filterTaskDateRangeType}`;
      }

      if (filterTaskFromDate != "" || filterTaskToDate != "") {
        requestUrl =
          requestUrl +
          `&filterfromdate=${filterTaskFromDate}&filtertodate=${filterTaskToDate}`;
      }

      if (filterTaskCustomIds.length > 0) {
        requestUrl = requestUrl + `&filtertaskcustomids=${filterTaskCustomIds}`;
      }

      if (filterTaskTitle != "") {
        requestUrl = requestUrl + `&filtertitle=${filterTaskTitle}`;
      }

      if (filterTaskLabels.length > 0) {
        requestUrl = requestUrl + `&filtertags=${filterTaskLabels}`;
      }
      if (filterTaskStatus.length > 0) {
        requestUrl = requestUrl + `&filtercompletestatus=${filterTaskStatus}`;
      }
      if (filterTaskPriorities.length > 0) {
        requestUrl = requestUrl + `&filterpriorities=${filterTaskPriorities}`;
      }

      if (filterTaskAssignedByUsers.length > 0) {
        requestUrl =
          requestUrl + `&filtermoderators=${filterTaskAssignedByUsers}`;
      }

      if (filterTaskAssignedToUsers.length > 0) {
        requestUrl = requestUrl + `&filterusers=${filterTaskAssignedToUsers}`;
      } else if (params.userid) {
        requestUrl = requestUrl + `&filterusers=${params.userid}`;
      }

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      // console.log("response in task list------->", response);

      if (response.status) {
        if (response.data.length === 0) {
          setHideEmptyMessage(false);
        }

        const newGanttTasks = response.data
          .sort((a, b) => b.rank - a.rank)
          .map((task) => {
            const taskTitle = task.ismilestone
              ? `${task.title}`
              : `${task.customid} ${task.title}`;

            return {
              start: new Date(task.startdate), // task start date
              end: new Date(task.enddate), // task end date,
              name: taskTitle, // task title
              project: task.projectname, // project title
              moderator: task.moderator._id,
              id: task._id, // task mongo id
              type: task.ismilestone ? "milestone" : "task", // type = task, milestone, project
              progress: task.taskpercent, // % done
              isDisabled: false,
              hideChildren: false,
              styles: {
                progressColor: "#ffbb54",
                progressSelectedColor: "#ff9e0d",
              },
              dependencies: task.previoustask ? [task.previoustask] : [], // previous task mongo id
            };
          });

        setTaskList(newGanttTasks);
        // resetFilterData();

        setAlertMessage(response.message);
        setMessageType("success");
        setShowAlert(true);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  // get tasks by filter
  const getTasksByFilter = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_TASKS + `?token=${token}`;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        if (response.data.length === 0) {
          setHideEmptyMessage(false);
        }

        const newGanttTasks = response.data.map((task) => {
          const taskTitle = task.ismilestone
            ? `${task.title}`
            : `${task.customid} ${task.title}`;

          return {
            start: new Date(task.startdate), // task start date
            end: new Date(task.enddate), // task end date,
            name: taskTitle, // task title
            project: task.projectname, // project title
            moderator: task.moderator._id,
            id: task._id, // task mongo id
            type: task.ismilestone ? "milestone" : "task", // type = task, milestone, project
            progress: task.taskpercent, // % done
            isDisabled: false,
            hideChildren: false,
            styles: {
              progressColor: "#ffbb54",
              progressSelectedColor: "#ff9e0d",
            },
            dependencies: task.previoustask ? [task.previoustask] : [], // previous task mongo id
          };
        });

        setTaskList(newGanttTasks);
        // resetFilterData();

        setAlertMessage(response.message);
        setMessageType("success");
        setShowAlert(true);
      } else {
        setMessageType("error");
      }

      setIsLoading(false);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
  };

  //function for update date of task
  const onTaskDateChange = (e) => {
    const startDate = getConvertedGanttDate(e.start);
    const endDate = getConvertedGanttDate(e.end);

    setUpdatedTaskId(e.id);
    setUpdatedStartDate(startDate);
    setUpdatedEndDate(endDate);
    setShowUpdateButtons(true);

    // const bootstrapModal = new bootstrap.Modal(
    //   document.getElementById("projectTaskGanttModal")
    // );
    // bootstrapModal.show();
  };

  const onUpdateGanttTask = async (change, unlink) => {
    try {
      let taskData = {
        startdate: updatedStartDate,
        enddate: updatedEndDate,
        ischange: change,
        isunlink: unlink,
      };

      console.log(taskData);

      let response = {};

      if (updatedTaskId) {
        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_GANTT_TASK +
          `/${updatedTaskId}?token=${token}`;

        response = await putData(requestUrl, taskData);
      }

      // console.log(response);

      if (response.status) {
        resetUpdatedTaskData();
        seterrorMessage("");
        getAllTask(isProjectModerator);

        setMessageType("success");
      } else {
        seterrorMessage(response.message);

        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for change progress
  const onTaskProgressChange = async (e) => {
    try {
      let taskData = {
        taskpercent: e.progress,
      };

      // console.log(taskData);

      let response = {};

      if (e.id) {
        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_PROJECT_TASK +
          `/${e.id}?token=${token}`;

        response = await putData(requestUrl, taskData);
      }

      // console.log(response);

      if (response.status) {
        seterrorMessage("");
        setMessageType("success");
      } else {
        seterrorMessage(response.message);
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      // console.log(error.message);
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //fucntion for open task popup and update
  const onClickTask = (e) => {
    // console.log(e);
    setSelectedEditTaskId(e.id);

    setselectedTaskModerator(e.moderator);

    // Get the offcanvas element
    var taskCanvas = document.getElementById("addTask_view");
    // Trigger the offcanvas using Bootstrap's built-in methods
    var offcanvas = new bootstrap.Offcanvas(taskCanvas);
    offcanvas.toggle(); // Toggle the offcanvas
  };

  const refreshRecords = () => {
    resetFilterData();
  };

  //function for reset filter
  const resetFilterData = () => {
    setFilterTaskDateRangeType("");
    setfilterTaskFromDate("");
    setfilterTaskToDate("");
    setfilterTaskCustomIds([]);
    setfilterTaskTitle("");
    setfilterTaskLabels([]);
    setfilterTaskStatus([]);
    setfilterTaskPriorities([]);
    setfilterTaskProjects([]);
    setfilterTaskAssignedToUsers([]);
    setfilterTaskAssignedByUsers([]);
    setGanttViewStartDate(getCurrentMonthFirstDate());
    setView(ViewMode.Month);
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  //reset update task data from date
  const resetUpdatedTaskData = () => {
    setView(ViewMode.Month);
    setUpdatedTaskId(null);
    setUpdatedStartDate("");
    setUpdatedEndDate("");
    setShowUpdateButtons(false);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getTasksByFilter();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllTask();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    resetUpdatedTaskData();
    //getAllTask();
  }, []);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_PROJECT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            <MyTaskGanttHeader
              reloadList={refreshRecords}
              jsonFilterQuery={jsonFilterQuery}
            />

            {/* -------- gantt board here---------- */}
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="project-tasks-container">
                <GanttViewSwitcher
                  onViewModeChange={(viewMode) => setView(viewMode)}
                  onViewListChange={setIsChecked}
                  isChecked={isChecked}
                  showUpdateButtons={showUpdateButtons}
                  resetUpdatedTaskData={resetUpdatedTaskData}
                  onUpdateGanttTask={onUpdateGanttTask}
                />

                {taskList.length === 0 ? (
                  hideEmptyMessage ? null : (
                    <div className="challenges_empty text-center">
                      <div className="empty_pic mb-4">
                        {" "}
                        <img src={assetImages.emptyVector} alt="" />
                      </div>
                      <div className="empty_text">
                        <p className="fs-lg text-gray fw-semibold mb-4">
                          Sorry! No Tasks available at this moment.
                        </p>
                      </div>
                    </div>
                  )
                ) : (
                  <Gantt
                    ganttHeight={800}
                    tasks={taskList}
                    viewMode={view}
                    viewDate={ganttViewStartDate}
                    preStepsCount={0}
                    onDateChange={(e) => {
                      onTaskDateChange(e);
                    }}
                    onTaskDelete={(e) => {
                      console.log("onTaskDelete fired ---->");
                      console.log(e);
                    }}
                    onProgressChange={(e) => {
                      onTaskProgressChange(e);
                    }} // returns the progress
                    onDoubleClick={(e) => {
                      console.log("onDoubleClick fired ---->");
                      console.log(e);
                    }} // event is firing and it returns the task
                    onClick={(e) => {
                      onClickTask(e);
                    }} // event is firing and it returns the task
                    columnWidth={columnWidth}
                    listCellWidth={isChecked ? "200px" : ""}
                  />
                )}
              </div>
            )}
          </div>
        </section>

        {/* ========== popups and modal area ======== */}
        <TaskManagementPopup
          projectId={null}
          leadId={null}
          contactId={null}
          selectedTaskModerator={selectedTaskModerator}
          selectedSectionValue={null}
          sectionOptions={[]}
          memberList={memberList}
          selectedTaskId={selectedEditTaskId}
          onPopUpClose={() => {
            setSelectedEditTaskId(null);
            // setselectedTaskModerator(null);
            // setSelectedSectionValue(null);
          }}
          getTaskList={() => {
            setTimeout(() => {
              getAllTask();
            }, 2200);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* ------- filter popup --------- */}
        {/* ------- filter popup --------- */}
        {/* <MyTaskFilterPopup
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          filterTaskDateRangeType={filterTaskDateRangeType}
          setFilterTaskDateRangeType={setFilterTaskDateRangeType}
          filterTaskFromDate={filterTaskFromDate}
          setfilterTaskFromDate={setfilterTaskFromDate}
          filterTaskToDate={filterTaskToDate}
          setfilterTaskToDate={setfilterTaskToDate}
          filterTaskCustomIds={filterTaskCustomIds}
          setfilterTaskCustomIds={setfilterTaskCustomIds}
          filterTaskTitle={filterTaskTitle}
          setfilterTaskTitle={setfilterTaskTitle}
          filterTaskProjects={filterTaskProjects}
          setfilterTaskProjects={setfilterTaskProjects}
          filterTaskAssignedByUsers={filterTaskAssignedByUsers}
          setfilterTaskAssignedToUsers={setfilterTaskAssignedToUsers}
          filterTaskAssignedToUsers={filterTaskAssignedToUsers}
          setfilterTaskAssignedByUsers={setfilterTaskAssignedByUsers}
          filterTaskStatus={filterTaskStatus}
          setfilterTaskStatus={setfilterTaskStatus}
          filterTaskPriorities={filterTaskPriorities}
          setfilterTaskPriorities={setfilterTaskPriorities}
          filterTaskLabels={filterTaskLabels}
          setfilterTaskLabels={setfilterTaskLabels}
          moduleName="mytaskgantt"
        /> */}

        <TaskAdvanceFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          moduleSlug="mytask"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        <UpdateGanttTaskModal onUpdateGanttTask={onUpdateGanttTask} />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default MyTaskGanttBody;
